<div class="step-view" [ngClass]="{ 'last-step': isLastStep, 'flip-icon': isFlipArrowIcon }">
  @if (!isLastStep) {
    <div class="stepper-progress" [ngClass]="{ passed: step.state === StepState.COMPLETED }"></div>
  }

  <pc-icon
    class="state-icon"
    [ngClass]="{
      'current-icon': step.state === StepState.CURRENT,
      'unselected-icon': step.state === StepState.FUTURE,
      hidden: step.state !== StepState.COMPLETED,
      visible: step.state === StepState.COMPLETED
    }"
    [icon]="PcButtonIcon.CIRCLE_CHECKBOX_SELECTED"
    [size]="'small'"
  ></pc-icon>
  <pc-icon
    class="state-icon"
    [ngClass]="{
      'current-icon': step.state === StepState.CURRENT,
      'unselected-icon': step.state === StepState.FUTURE,
      hidden: step.state !== StepState.CURRENT,
      visible: step.state === StepState.CURRENT
    }"
    [icon]="PcButtonIcon.CIRCLE_RIGHT"
    [size]="'small'"
  ></pc-icon>
  <pc-icon
    class="state-icon"
    [ngClass]="{
      'current-icon': step.state === StepState.CURRENT,
      'unselected-icon': step.state === StepState.FUTURE,
      hidden: step.state !== StepState.FUTURE,
      visible: step.state === StepState.FUTURE
    }"
    [icon]="PcButtonIcon.CIRCLE_CHECKBOX_UNSELECTED"
    [size]="'small'"
  ></pc-icon>
  <span class="step-name" [ngClass]="{ 'current-step': step.state === StepState.CURRENT }">{{ step.name }}</span>
</div>
